module.exports = __webpack_public_path__ + "img/wrn.69d657fd.svg";